/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinesQuestion.module.scss'
import { useHistory } from 'react-router-dom'

const FinesQuestionView = ({ t, i18n }) => {
  let history = useHistory()

  const handleYes = () => {
    history.push(`/${i18n.language}${t('routes.fines_yes')}`)
  }

  const handleNo = () => {
    history.push(`/${i18n.language}${t('routes.school_question')}`)
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div className={styles['margin_back']}>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <a
                  onClick={() => history.push(`/${i18n.language}${t('routes.privacy_notice')}`)}
                  href={`/${i18n.language}${t('routes.privacy_notice')}`}
                >
                  {t('fines_question.back')}
                  <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
                </a>
              </div>
            </div>
          </div>
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs- col-md-8">
          <h3>{t('fines_question.question')}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <button className={'btn-lg btn-default'} onClick={handleYes} value={t('fines_question.yes')} name={t('fines_question.yes')}>
            {t('fines_question.yes')}
          </button>
          <button
            className={['btn-lg btn-default', styles['margin_left_20']].join(' ')}
            onClick={handleNo}
            value={t('fines_question.no')}
            name={t('fines_question.no')}
          >
            {t('fines_question.no')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(FinesQuestionView)
